module.exports = __webpack_public_path__ + "static/media/wa2.a59af0e5.png";